import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthGroupService } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.service';
import { InitializeAuthGroupSignal } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.signals';
import { filter, switchMap, tap } from 'rxjs';

import { TRUST_ADJUSTMENTS_AUTH_GROUPS } from '@ln/timesheet-adjustments-util';

export const timesheetAdjustmentsGuard: CanActivateFn = () => {
  const authGroupService = inject(AuthGroupService);
  const router = inject(Router);
  const store = inject(Store);

  store.dispatch(new InitializeAuthGroupSignal({}));

  return authGroupService
    .isLoaded()
    .pipe(
      filter((isLoaded) => isLoaded),
      switchMap(() =>
        authGroupService.getOfficerBelongsToAnyOfTheAuthGroups(TRUST_ADJUSTMENTS_AUTH_GROUPS),
      ),
    )
    .pipe(tap((hasGroup) => hasGroup || router.navigateByUrl('dashboard')));
};
